import {
    BaseBoxShapeUtil,
    HTMLContainer,
    RecordProps,
    T,
    TLBaseShape,
    stopEventPropagation,
    TLResizeHandle,
} from 'tldraw'
import {TaskStatusType} from "../types/taskFlow.types";
import CircularProgress from "@mui/material/CircularProgress";
import {ViewDetail} from '../icons/'
import { setCurrentLevel2TaskId } from '../store/taskSlice';
import { store } from '../store';


type IMyEditableShape = TLBaseShape<
    'task-loading-shape',
    {
        text: string,
        status: string,
        h: number,
        w: number,
        loading: boolean
        taskId: number
        showLeve2: boolean
    }
>

export class TaskLoadingShapeUtil extends BaseBoxShapeUtil<IMyEditableShape> {
    static override type = 'task-loading-shape' as const
    static override props: RecordProps<IMyEditableShape> = {
        text: T.string,
        status: T.string,
        w: T.number,
        h: T.number,
        loading: T.boolean,
        taskId: T.number,
        showLeve2: T.any
    }


    getDefaultProps(): IMyEditableShape['props'] {
        return {
            text: '对【蛇元素】和【新中式】进行发散联想',
            status: '待确认',
            w: 260,
            h: 40,
            loading: true,
            taskId: 0,
            showLeve2: false
        }
    }

    // 禁用调整大小功能
    override canResize = (_shape: IMyEditableShape) => {
        return false
    }

    // 隐藏调整大小的控制点
    override hideResizeHandles = (_shape: IMyEditableShape): boolean => {
        return true
    }

    // [2]
    component(shape: IMyEditableShape) {
        // [a]
        const isEditing = this.editor.getEditingShapeId() === shape.id

        return (
            <>
                {/*<div style={{ marginTop: "-15px", textAlign: "center", fontSize: "10px", color: "gray"}}>{shape.props.taskId}</div>*/}
                <HTMLContainer
                    id={shape.id}
                    // [b]
                    onPointerDown={isEditing ? stopEventPropagation : undefined}
                    style={{
                        pointerEvents: 'all',
                        borderBottom: '1px solid #DDDDDD',
                        fontSize: 14,
                        padding: 8,
                        /*borderRadius: 20,*/
                        color: '#444444'
                    }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'center',
                    }}>
                        {/*{shape.props.loading && <CircularProgress size={28}/>}*/}
                        {/*<div style={{width: 30}}></div>*/}
                        <div style={{
                            fontWeight: "bold",
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            color: '#444444',
                            maxWidth: 'calc(100% - 60px)'  // 减去loading图标和边距的宽度
                        }}><span style={{color: "gray"}}>{/*`【{shape.props.taskId}】`*/}</span>{shape.props.text}</div>
{/*                        <div style={{
                            cursor: 'pointer',
                            backgroundColor:'white',
                            padding: 6,
                            marginLeft: 4,
                            display: 'flex',
                            borderRadius: 8,
                            visibility: shape.props.showLeve2 ? 'visible' : 'hidden',
                        }} onPointerDown={(e) => {
                            if (!shape.props.showLeve2) return;
                            e.stopPropagation();
                            store.dispatch(setCurrentLevel2TaskId(shape.props.taskId));
                        }}><ViewDetail /></div>*/}
                    </div>
                </HTMLContainer>
            </>
        )
    }

    indicator(shape: IMyEditableShape) {
        // 返回固定大小的indicator
        return <rect width={shape.props.w} height={shape.props.h} />
    }
}